import React from 'react';
import { Dashboard } from './components/leaderDashboard/Dashboard';
export function App() {
  return <Dashboard data-id="element-0" />;
}